export const getDeposit = (deposit_id) => ({ deposit }) =>
  deposit.depositList.find(({ id }) => id === deposit_id);
